/**
 * Pet skins in shop.json's catalogue (docs/PETS.md, Pets v2), checked against the pets.json roster: a pet skin names the
 * pet it fits (`pet`, required for kind "pet" and refused on every other kind) and is had only by catching that pet
 * wearing it (`caught: true`, a pet skin's only unlock). Used by data/commerce.ts parseSkins.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Json = any;

/** The roster a pet skin is checked against: the pet ids (none in an older bundle). */
export interface PetRoster { readonly ids: readonly string[] }

export function petRoster(root: Json): PetRoster {
  const p = root?.pets;
  return { ids: ((p?.pets ?? []) as Json[]).map((x) => String(x?.id)) };
}

/** A pet skin's `caught` unlock: `caught: true` on a pet skin. Throws on anything else. */
export function caughtUnlock(id: string, kind: string, k: Json): { readonly by: "caught" } {
  if (kind !== "pet" || k.caught !== true) throw new Error(`skin '${id}': caught needs a pet skin and caught: true`);
  return { by: "caught" };
}

/** The pet a skin fits: its `pet` for kind "pet" (a roster id, no `tower`, unlocked by `caught`), undefined for any other kind without one. Throws on anything else. */
export function skinPet(id: string, kind: string, k: Json, pets: PetRoster): string | undefined {
  if (kind !== "pet" && !("pet" in k)) return undefined;
  const pet = typeof k.pet === "string" ? k.pet : "";
  if (kind !== "pet" || !pets.ids.includes(pet) || "tower" in k) throw new Error(`skin '${id}': pet '${pet}' needs a pet skin and a pet id`);
  if (k.caught !== true) throw new Error(`skin '${id}': a pet skin is had only by catching its pet (caught: true)`);
  return pet;
}
